import ReactDOM from 'react-dom/client';
import './index.css';
import 'bootstrap/dist/css/bootstrap.css';
import Router from './router/Router';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(<Router />);
